import { Navigate } from "react-router-dom";
const RequireAuth = ({ children }) => {
  let accessToken = localStorage.getItem("kyrusToken");
  if (!accessToken) {
    return <Navigate to="/" replace />;
  }
  return children;
}

export default RequireAuth;
